import React, { Component } from 'react';
import { Big3Common } from '../../js/IncludeManager';
import { ListGoods } from './ListGoods';
import { ListWhole } from './ListWhole';
/* 개발담당:양유빈
 * 화면기능:플랫폼 메인 리스트 처리
 * 세부설명:
*/

export class ListContainer extends Component {
    static displayName = ListContainer.name;

    constructor(props) {
        super(props);
        this.state = {
            ContentConmgr: ""
        };
        this.index = -1;
    }
    //초기화
    componentDidMount() {
        const ContentConmgr = Big3Common.Util.GetContentState(this.props, "data-info", null);
        this.index = Big3Common.Util.GetContentState(this.props, "index", -1);
        if (ContentConmgr !== null) {
            this.setState({ ContentConmgr: ContentConmgr });
        }
    }
 
    render() {
        const ContentConmgr = this.state.ContentConmgr;
        const cntt_tye = ContentConmgr.cntt_tye;
        const mgr_no = ContentConmgr.mgr_no;
        const index = this.index;
        if (cntt_tye === "GO") {
            return (
                <ListGoods key={`${mgr_no}_${index}`}
                    data-info={ContentConmgr}
                    GoodsDtlShow={this.props.GoodsDtlShow}
                    index={this.props.index}
                    listcount={this.props.listcount}
                />
            )
        }
        else if (cntt_tye === "WH") {
            return (
                <ListWhole key={`${mgr_no}_${index}`}
                    data-info={ContentConmgr}
                    GoodsDtlShow={this.props.GoodsDtlShow}
                    index={this.props.index}
                />
            )
        }
        else {
            return (
                "컨텐츠준비중입니다."
            )
        }
    }
}
